import LoginEditPage from './LoginEditPage'

export default LoginEditPage
